import React from "react"
import {getOrgName, Org} from "../../resources/org"
import {Filter} from "../Filter/Filter"
import moment from "moment"
import {AsyncResultRequestState} from "../../types/asyncResult"
import {ErrorDocument, RiskRate} from "../../resources/common"

const noOrgData: Org = {
	id: "-1",
	type: "org",
	attributes: {
		createdAt: new Date(Date.now()),
		name: "N/A",
		defaultCustomerRiskRate: RiskRate.Low,
		orgInterchangeShare: 0,
		enableTwoFactorAuthentication: false,
	},
}

export const OrgFilter = (
	orgs: AsyncResultRequestState<Org[], ErrorDocument>,
	setFilteredOrgs: (orgs: string[]) => void,
	filteredOrgs: string[],
	reset: (limit: number) => void,
	limit: number,
	singleSelect = false
) => {
	const managedSolutionsOrgs = orgs.match(
		() => [],
		(orgs) => orgs.filter((org) => typeof org.relationships?.parentOrg !== "undefined").map((org) => org.id),
		() => []
	)

	return orgs.match(
		() => null,
		(orgs) => (
			<Filter
				title="Orgs"
				isSearchable
				setStatuses={setFilteredOrgs}
				statuses={filteredOrgs}
				onFilterFunc={() => reset(limit)}
				singleSelect={singleSelect}
				options={
					new Map<string, string>(
						(singleSelect ? [...orgs] : [...orgs, noOrgData])
							.sort((a, b) => moment(b.attributes.createdAt).diff(moment(a.attributes.createdAt)))
							.map((org) => [org.id, getOrgName(org)])
					)
				}
				customSelections={
					singleSelect
						? undefined
						: [
								{
									name: "Managed Solutions",
									filterFn: ([option, _]) => {
										return managedSolutionsOrgs.includes(option as string)
									},
								},
						  ]
				}
				virtualized
			/>
		),
		(_) => null
	)
}
